const requiredCandidateFields = require('./validator-helper/requiredFields.json');

const getMissingFields = (requiredPaths, jsonObject) => {
    return requiredPaths.filter(path => {
        const value = _.get(jsonObject, path);
        return value === undefined || value === null;
    });
}

export const validateCandidateJson = (candidateJson) => {
    return getMissingFields(requiredCandidateFields.fields, candidateJson);
}